import brand1 from "../assets/images/brand1.png";
import brand2 from "../assets/images/brand2.png";
import brand3 from "../assets/images/brand3.png";
const BRAND_DATA = [
  {
    id: "1",
    imageUrl: `${brand1}`,
    name: "a",
  },
  {
    id: "2",
    imageUrl: `${brand2}`,
    name: "b",
  },
  {
    id: "3",
    imageUrl: `${brand3}`,
    name: "c",
  },
  {
    id: "4",
    imageUrl: `${brand1}`,
    name: "d",
  },
  {
    id: "5",
    imageUrl: `${brand2}`,
    name: "e",
  },
  {
    id: "6",
    imageUrl: `${brand3}`,
    name: "f",
  },
  {
    id: "7",
    imageUrl: `${brand1}`,
    name: "g",
  },
  {
    id: "8",
    imageUrl: `${brand2}`,
    name: "h",
  },
  {
    id: "9",
    imageUrl: `${brand3}`,
    name: "i",
  },
  {
    id: "10",
    imageUrl: `${brand1}`,
    name: "j",
  },
  {
    id: "11",
    imageUrl: `${brand2}`,
    name: "k",
  },
  {
    id: "12",
    imageUrl: `${brand3}`,
    name: "l",
  },
  {
    id: "13",
    imageUrl: `${brand1}`,
    name: "m",
  },
  {
    id: "14",
    imageUrl: `${brand2}`,
    name: "n",
  },
  {
    id: "15",
    imageUrl: `${brand3}`,
    name: "o",
  },
];

export default BRAND_DATA;
